export default __webpack_public_path__ + "static/contact-801bb9dc1ce760be8ee3d84cd758a89a.svg";